import {
  DoraEnvironment,
  DoraHistoryPoint,
  DoraMetrics,
  DoraMetricsApi,
  DoraTargets,
} from './types';

const MOCK_ENVIRONMENTS: DoraEnvironment[] = [
  {
    name: 'Production',
    branch: 'main',
    isProduction: true,
    label: 'срочный фикс',
  },
  { name: 'Staging', branch: 'develop', isProduction: false, label: '' },
];

const MOCK_TARGETS: DoraTargets = {
  deploymentFrequency: 7,
  leadTime: 24,
  changeFailureRate: 15,
  mttr: 1,
};

const MOCK_MERGE_REQUESTS = [
  {
    number: 24,
    title: 'Добавить экспорт витрины метрик',
    url: '/project/team-bar/demo901/merge-request/24',
    durationHours: 31.2,
    mergedAt: '2026-07-01T12:48:20Z',
    author: 'rtruschev',
    authorAvatar:
      'https://gf.bootsman.team/upload/-/user/7d3f98a7-e2d2-49aa-ac3e-c22aef3128cc/avatar/12e2fe18-7aaf-4d59-a5c1-d90ce0ae05dc.png',
  },
  {
    number: 22,
    title: 'Обновить обработку статусов конвейера',
    url: '/project/team-bar/demo901/merge-request/22',
    durationHours: 22.5,
    mergedAt: '2026-06-29T09:17:00Z',
    author: 'akuznetsov',
    authorAvatar: 'https://gf.bootsman.team/static/image/avatar.jpg',
  },
  {
    number: 19,
    title: 'Поддержать фильтр по рабочей ветке',
    url: '/project/team-bar/demo901/merge-request/19',
    durationHours: 18.8,
    mergedAt: '2026-06-26T16:45:00Z',
    author: 'mivanova',
    authorAvatar: 'https://gf.bootsman.team/static/image/avatar.jpg',
  },
  {
    number: 17,
    title: 'Обновить шаблон карточки сервиса',
    url: '/project/team-bar/demo901/merge-request/17',
    durationHours: 14.1,
    mergedAt: '2026-06-24T11:30:00Z',
    author: 'sergey',
    authorAvatar: 'https://gf.bootsman.team/static/image/avatar.jpg',
  },
  {
    number: 14,
    title: 'Добавить пагинацию списка окружений',
    url: '/project/team-bar/demo901/merge-request/14',
    durationHours: 9.6,
    mergedAt: '2026-06-21T13:20:00Z',
    author: 'rtruschev',
    authorAvatar:
      'https://gf.bootsman.team/upload/-/user/7d3f98a7-e2d2-49aa-ac3e-c22aef3128cc/avatar/12e2fe18-7aaf-4d59-a5c1-d90ce0ae05dc.png',
  },
];

const MOCK_HOTFIX_MERGE_REQUESTS = [
  {
    number: 23,
    title: 'Fix read timeout',
    url: '/project/team-bar/demo901/merge-request/23',
    durationHours: 1.2,
    mergedAt: '2026-06-30T03:45:00Z',
    author: 'rtruschev',
    authorAvatar:
      'https://gf.bootsman.team/upload/-/user/7d3f98a7-e2d2-49aa-ac3e-c22aef3128cc/avatar/12e2fe18-7aaf-4d59-a5c1-d90ce0ae05dc.png',
  },
  {
    number: 16,
    title: 'Исправить ошибку синхронизации владельца',
    url: '/project/team-bar/demo901/merge-request/16',
    durationHours: 0.8,
    mergedAt: '2026-06-23T22:10:00Z',
    author: 'akuznetsov',
    authorAvatar: 'https://gf.bootsman.team/static/image/avatar.jpg',
  },
];

const MOCK_HISTORY: DoraHistoryPoint[] = [
  {
    weekLabel: 'Jun 3',
    bucketMidMs: new Date('2026-06-03').getTime(),
    deploymentCount: 3,
    leadTimeHours: 24.1,
    changeFailureRate: 0,
    mttrHours: 0,
  },
  {
    weekLabel: 'Jun 10',
    bucketMidMs: new Date('2026-06-10').getTime(),
    deploymentCount: 5,
    leadTimeHours: 19.8,
    changeFailureRate: 20,
    mttrHours: 1.2,
  },
  {
    weekLabel: 'Jun 17',
    bucketMidMs: new Date('2026-06-17').getTime(),
    deploymentCount: 4,
    leadTimeHours: 22.3,
    changeFailureRate: 0,
    mttrHours: 0,
  },
  {
    weekLabel: 'Jun 24',
    bucketMidMs: new Date('2026-06-24').getTime(),
    deploymentCount: 6,
    leadTimeHours: 16.5,
    changeFailureRate: 16.7,
    mttrHours: 0.9,
  },
  {
    weekLabel: 'Jul 1',
    bucketMidMs: new Date('2026-07-01').getTime(),
    deploymentCount: 5,
    leadTimeHours: 18.4,
    changeFailureRate: 0,
    mttrHours: 0,
  },
];

export class MockDoraMetricsClient implements DoraMetricsApi {
  getEnvironments(): DoraEnvironment[] {
    return MOCK_ENVIRONMENTS;
  }

  getDefaultDays(): number {
    return 30;
  }

  getTargets(): DoraTargets {
    return MOCK_TARGETS;
  }

  async getMetrics(
    _projectSlug: string,
    env: DoraEnvironment,
    _days: number,
    _targetsOverride?: Partial<DoraTargets>,
  ): Promise<DoraMetrics> {
    await new Promise(r => setTimeout(r, 600)); // simulate network delay

    return {
      deploymentFrequency: {
        value: 4.2,
        unit: 'per week',
        rating: 'high',
        target: 7,
        slowestPRs: MOCK_MERGE_REQUESTS,
      },
      leadTime: {
        value: 18.4,
        unit: 'hours',
        rating: 'elite',
        target: 24,
        slowestPRs: MOCK_MERGE_REQUESTS,
      },
      changeFailureRate: env.isProduction
        ? { value: 8.3, unit: '%', rating: 'high', target: 15 }
        : null,
      mttr: env.isProduction
        ? {
            value: 0.8,
            unit: 'hours',
            rating: 'elite',
            target: 1,
            slowestPRs: MOCK_HOTFIX_MERGE_REQUESTS,
          }
        : null,
      numberOfHotfixes: env.isProduction
        ? {
            value: 2,
            unit: 'MRs',
            rating: 'high',
            target: 0,
            slowestPRs: MOCK_HOTFIX_MERGE_REQUESTS,
          }
        : null,
    };
  }

  async getHistory(
    _projectSlug: string,
    env: DoraEnvironment,
    _days: number,
  ): Promise<DoraHistoryPoint[]> {
    await new Promise(r => setTimeout(r, 400));

    return MOCK_HISTORY.map(point => ({
      ...point,
      changeFailureRate: env.isProduction ? point.changeFailureRate : undefined,
      mttrHours: env.isProduction ? point.mttrHours : undefined,
    }));
  }
}
